const {
  TCP,
  GYM,
  TCP_CMS,
  GYM_CMS,
  SNJ,
  SNJ_CMS,
  PJP,
  PJP_CMS,
  CLEARANCE,
  CLEARANCE_CMS,
} = require('./brands.constants');

const BRAND_CONFIG_OPTION = {
  [TCP]: {
    brandId: TCP.toLowerCase(),
    brandIdCMS: TCP_CMS,
  },
  [GYM]: {
    brandId: GYM.toLowerCase(),
    brandIdCMS: GYM_CMS,
  },
  [SNJ]: {
    brandId: SNJ.toLowerCase(),
    brandIdCMS: SNJ_CMS,
  },
  [PJP]: {
    brandId: PJP.toLowerCase(),
    brandIdCMS: PJP_CMS,
  },
  [CLEARANCE]: {
    brandId: CLEARANCE.toLowerCase(),
    brandIdCMS: CLEARANCE_CMS,
  },
};

const CATALOG_ID_CONFIG = {
  [TCP]: {
    USA: '10551',
    Canada: '10552',
  },
  [GYM]: {
    USA: '10555',
    Canada: '10556',
  },
  [SNJ]: {
    // BRAND-SPECIFIC-TODO
    USA: '10551',
    Canada: '10552',
  },
  [PJP]: {
    USA: '10551',
    Canada: '10552',
  },
  [CLEARANCE]: {
    USA: '10551',
    Canada: '10552',
  },
};

const COUNTRY_CODE_NAME_MAPPING = {
  US: 'USA',
  CA: 'Canada',
};
// switch brand to test
const DEFAULT_BRAND = TCP.toLowerCase(); // this is used for local development specific to tcp
const ImageBadgeUrl = 'l_ecom:assets:static:badge:';
const IMAGES_BADGE_PARAMS_PATH = {
  [TCP]: ImageBadgeUrl,
  [GYM]: ImageBadgeUrl,
  [SNJ]: 'l_ecom:assets:static:badge:purple:',
  [PJP]: ImageBadgeUrl,
};

module.exports = {
  BRAND_CONFIG_OPTION,
  CATALOG_ID_CONFIG,
  COUNTRY_CODE_NAME_MAPPING,
  DEFAULT_BRAND,
  IMAGES_BADGE_PARAMS_PATH,
};
